import { ActionTypes } from "../../constants/ActionTypes";
import { ISecretariatReducer } from "../../interfaces/Secretariat";

const INIT_STATE: ISecretariatReducer = {
    secretariatList: [],
    searchText: "",
};

export default (state = INIT_STATE, action: any) => {
    switch (action.type) {
        case ActionTypes.GET_SECRETARIAT_LIST: {
            return {
                ...state,
                searchText: action.payload,
            };
        }

        case ActionTypes.FETCH_SECRETARIAT_LIST_SUCCESS: {
            return {
                ...state,
                secretariatList: action.payload,
            };
        }

        default:
            return state;
    }
};
